import request from '@/utils/request'
import type { Product } from '@/types/product'
import type { Cases } from "@/types/cases"
import type { News } from "@/types/news"
import type { ProductKind } from "@/types/productKind"
import type { AboutUs } from '@/types/aboutUs'
import { Messages } from '@/types/messages'


//首页轮播图列表
export const getBannerList = () => {
    return request.get<AboutUs[]>('/company/getBanner')
}

  
// 成功案例
export const getCasesList = () => {
  return request.get<Cases[]>('/company/getCases')
}

// 分类列表
export const getCategory = () => {
  return request.get<ProductKind[]>('/company/getCategory')
}

// 一级分类列表
export const getCategoryFirst = () => {
  return request.get<ProductKind[]>('/company/getCategoryFirst') 
}

// 获取产品列表
export const getProductListByKindId = (id?:number) => {
  return request.get<Product[]>(`/company/getProductListByKindId/${id}`)
}

// 首页公司实力
export const getCompanyStrength = () => {
  return request.get<AboutUs[]>('/company/getCompanyStrength')
}

//公司简介和简介详情
export const getCompanyProfile = () => {
  return request.get<AboutUs[]>('/company/getCompanyProfile')
}

//新闻动态
export const getNewsDynamic = () => {
  return request.get<News[]>(`/company/getNewsDynamic`)
}

//获取首页联系我们
export const getContactUs = () => {
  return request.get<AboutUs[]>(`/company/getContactUs`)
}

//悬浮联系组件
export const getContactUsFloat = () => {
  return request.get<AboutUs[]>(`/company/getContactUsFloat`)
}

// 关于我们导航栏获取
export const getAboutUsNav = () => {
  return request.get<AboutUs[]>(`/company/getAboutUsNav`)
}

//联系我们页面数据
export const getContactUsPage = () => {
  return request.get<AboutUs[]>(`/company/getContactUsPage`)
}

// 新建设留言
export const createMessages = (data: Messages) => {
  return request.post<void>('/company/createMessages', data)
}

// 获取logo
export const getLogo = () => {
  return request.get<AboutUs>('/company/getLogo')
}